import { useEffect, useRef, useState } from 'react';

type ResizeObserverEntry = {
  // Note that `borderBoxSize` is preferred, but Safari
  // doesn't support it.
  contentRect: Array<{
    width: number;
    height: number;
  }>;
};

export const useResizeObserver = () => {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  useEffect(() => {
    const node = ref.current;
    let observer: any;
    // Use try / catch since testing environment may not understand `ResizeObserver`.
    try {
      // @ts-ignore ResizeObserver not understood yet
      observer = new ResizeObserver((entries: Array<ResizeObserverEntry>) => {
        const lastEntry = entries.pop();
        if (lastEntry) {
          // Different browsers use array or single object.
          const contentRect = Array.isArray(lastEntry.contentRect)
            ? lastEntry.contentRect[0]
            : lastEntry.contentRect;
          setWidth(contentRect.width);
          setHeight(contentRect.height);
        }
      });
      observer.observe(node);
      // eslint-disable-next-line no-empty
    } catch (e) {}
    return () => {
      // eslint-disable-next-line no-unused-expressions
      observer?.disconnect();
    };
  });
  return {
    ref,
    width,
    height,
  };
};
